// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadTicket_container__o3szY {
  min-height: calc(100vh - 230px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: #f5f7fa;
}

.loadTicket_centeredContent__29TFk {
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loadTicket_keyInputCard__dzmtk {
  width: 100%;
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loadTicket_cardTitle__mHkpu {
  color: #2c3e50;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
}

.loadTicket_inputContainer__ha28p {
  width: 100%;
  margin-bottom: 1.5rem;
}

.loadTicket_label__AAPrp {
  display: block;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #4a5568;
}

.loadTicket_input__V9EN6 {
  width: 100%;
  padding: 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-family: monospace;
  font-size: 0.9rem;
  background-color: #f8fafc;
  resize: vertical;
  transition: border-color 0.2s ease;
}
.loadTicket_input__V9EN6:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

.loadTicket_hint__bVW6r {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: #718096;
}

.loadTicket_submitBTN__Mkmln,
.loadTicket_downloadBTN__l42Fk {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;
  text-align: center;
  border: none;
}
.loadTicket_submitBTN__Mkmln:disabled,
.loadTicket_downloadBTN__l42Fk:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.loadTicket_submitBTN__Mkmln {
  background-color: #3182ce;
  color: white;
}
.loadTicket_submitBTN__Mkmln:hover:not(:disabled) {
  background-color: #2c5282;
}

.loadTicket_downloadBTN__l42Fk {
  background-color: #38a169;
  color: white;
}
.loadTicket_downloadBTN__l42Fk:hover {
  background-color: #2f855a;
}

.loadTicket_successTitle__HAck\\+ {
  color: #38a169;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-align: center;
}

.loadTicket_successText__PY59Q {
  color: #4a5568;
  margin-bottom: 1.5rem;
  text-align: center;
}

.loadTicket_spinner__k8ajI {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top-color: #3182ce;
  border-radius: 50%;
  animation: loadTicket_spin__GAmiz 0.8s linear infinite;
}

@keyframes loadTicket_spin__GAmiz {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/loadTicket.module.scss"],"names":[],"mappings":"AAEA;EACE,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,qBAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kCAAA;AADF;AAGE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AADJ;;AAKA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AAFF;;AAKA;;EAEE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAFF;AAIE;;EACE,YAAA;EACA,mBAAA;AADJ;;AAKA;EACE,yBAAA;EACA,YAAA;AAFF;AAIE;EACE,yBAAA;AAFJ;;AAMA;EACE,yBAAA;EACA,YAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sDAAA;AAJF;;AAOA;EACE;IACE,yBAAA;EAJF;AACF","sourcesContent":["// Add these new styles to your existing file\n\n.container {\n  min-height: calc(100vh - 230px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background-color: #f5f7fa;\n}\n\n.centeredContent {\n  width: 100%;\n  max-width: 600px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.keyInputCard {\n  width: 100%;\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.cardTitle {\n  color: #2c3e50;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.inputContainer {\n  width: 100%;\n  margin-bottom: 1.5rem;\n}\n\n.label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  color: #4a5568;\n}\n\n.input {\n  width: 100%;\n  padding: 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-family: monospace;\n  font-size: 0.9rem;\n  background-color: #f8fafc;\n  resize: vertical;\n  transition: border-color 0.2s ease;\n\n  &:focus {\n    outline: none;\n    border-color: #3182ce;\n    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\n  }\n}\n\n.hint {\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  color: #718096;\n}\n\n.submitBTN,\n.downloadBTN {\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 200px;\n  text-align: center;\n  border: none;\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.submitBTN {\n  background-color: #3182ce;\n  color: white;\n\n  &:hover:not(:disabled) {\n    background-color: #2c5282;\n  }\n}\n\n.downloadBTN {\n  background-color: #38a169;\n  color: white;\n\n  &:hover {\n    background-color: #2f855a;\n  }\n}\n\n.successTitle {\n  color: #38a169;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  text-align: center;\n}\n\n.successText {\n  color: #4a5568;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e2e8f0;\n  border-top-color: #3182ce;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `loadTicket_container__o3szY`,
	"centeredContent": `loadTicket_centeredContent__29TFk`,
	"keyInputCard": `loadTicket_keyInputCard__dzmtk`,
	"cardTitle": `loadTicket_cardTitle__mHkpu`,
	"inputContainer": `loadTicket_inputContainer__ha28p`,
	"label": `loadTicket_label__AAPrp`,
	"input": `loadTicket_input__V9EN6`,
	"hint": `loadTicket_hint__bVW6r`,
	"submitBTN": `loadTicket_submitBTN__Mkmln`,
	"downloadBTN": `loadTicket_downloadBTN__l42Fk`,
	"successTitle": `loadTicket_successTitle__HAck+`,
	"successText": `loadTicket_successText__PY59Q`,
	"spinner": `loadTicket_spinner__k8ajI`,
	"spin": `loadTicket_spin__GAmiz`
};
export default ___CSS_LOADER_EXPORT___;
